import axios from 'axios';
import { createRecurringAssignmentQuery } from './queries';

const addRecurringAssignment = (model) =>
    new Promise((resolve, reject) => {
        const query = createRecurringAssignmentQuery({ model });
        const request = axios.post(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add assignments'));
            });
    });

export default addRecurringAssignment;
